import { Box, Button, Grid, Slider, styled, SvgIcon, Typography, Stack, useTheme, useMediaQuery, Paper } from "@mui/material"
import { useEffect, useState } from "react"
import CustomScatterChart from "../charts/CustomScatterChart"
import DashboardDesktop from "./DashboardDesktop"
import DashboardMobile from "./DashboardMobile"
import React, { PureComponent } from 'react';
import DashboardCard from "../cards/DashboardCard.component"
import { createScatterChartArray } from "../../utils/chart"
import getDashboardCardsList from "../../utils/listGenerators"
import TrendScaleGraphic from "./TrendScaleGraphic"
import SchadflaechenChart from "../charts/SchadflaechenChart"


interface DashboardProps {
    dashboardData: any,
    layerSelection: any,
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    selectedPolygonId: string,
    setInfoPopup: Function
}


export default function Dashboard({ dashboardData, layerSelection, open, setOpen, selectedPolygonId, setInfoPopup }: DashboardProps) {


    useEffect(() => {
        selectedPolygonId !== "" && setOpen(true)
    }, [selectedPolygonId])


    let content
    let dashboardCardsInfo = getDashboardCardsList(dashboardData)
    const [ndviChartData, setNdviChartData] = useState<any>({
        data: [],
        trendSlope: 50,
    })
    const [ndwiChartData, setNdwiChartData] = useState<any>({
        data: [],
        trendSlope: 50,
    })

    // mobile
    const theme = useTheme();
    const tablet = useMediaQuery(theme.breakpoints.down('lg'));


    useEffect(() => {
        const indices = ["NDVI", "NDWI"]
        // Do this for NDVI and NDWI
        for (const index of indices) {
            let { outputArray, trendSlopeNormalized } = createScatterChartArray(index, dashboardData, layerSelection)
            if (index == "NDVI") {
                setNdviChartData({ data: outputArray, trendSlope: trendSlopeNormalized })
            }
            else if (index == "NDWI") {
                setNdwiChartData({ data: outputArray, trendSlope: trendSlopeNormalized })
            }
        }
    }, [dashboardData, layerSelection.period])

    content = (<>
        {
            layerSelection.layer1 === "ARNSBERG" ?
                // Schadflächen Chart
                <>
                    <Grid
                        direction="row"
                        container
                        // alignItems="flex-start"
                        spacing={0}
                    >
                        {/* <Grid container direction="row"> */}
                        <Grid container item direction="row" xs={12} md={12} lg={6} padding={2}>
                            {dashboardCardsInfo.map((cardInfo, index) => {
                                return <Grid item xs={12} md={4} p={2} key={index + "arnsberg"}>
                                    <DashboardCard description={cardInfo.description} value={cardInfo.value} metric={cardInfo.metric}
                                    />
                                </Grid>
                            })

                            }
                        </Grid>
                        <Grid container item xs={12} md={12} lg={6} padding={4} >
                            <SchadflaechenChart
                                key={dashboardData + "dashboardData"}
                                dashboardData={dashboardData}
                                title="Schadflächenstatistik 2016-2025"
                            />
                        </Grid>
                    </Grid>
                </>
                :
                // NDVI/NDWI Chart
                <>
                    <Grid
                        direction="row"
                        container
                        // alignItems="flex-start"
                        spacing={0}
                    >
                        {/* <Grid container direction="row"> */}
                        <Grid container item direction="row" xs={12} md={12} lg={6} padding={2}>
                            {dashboardCardsInfo.map((cardInfo, index) => {
                                return <Grid item xs={12} md={6} lg={4} p={2} key={index + "ndvi"}>
                                    <DashboardCard description={cardInfo.description} value={cardInfo.value} metric={cardInfo.metric}
                                    />
                                </Grid>
                            })
                            }
                        </Grid>
                        <Grid container item xs={12} md={12} lg={6} padding={2}>
                            <Grid item xs={12} lg={12} m={3} >
                                <Grid container item mb={1} alignItems="flex-start">
                                    <Grid item xs={12} md={11} lg={11}>
                                        {ndviChartData.data.length != 0 &&
                                            <CustomScatterChart
                                                type="NDVI"
                                                title="Trend Indikator Waldvitalität"
                                                dashboardData={ndviChartData.data}
                                                lowColor="#D14343"
                                                highColor="#65C18C"
                                                dataValueForLowColor={0}
                                                dataValueForHighColor={1}
                                                defaultColor="#65C18C"
                                                setInfoPopup={setInfoPopup}
                                            />
                                        }
                                    </Grid>
                                    <Grid item xs={12} md={1} lg={1} m={0}>
                                        <TrendScaleGraphic type="NDVI" value={ndviChartData.trendSlope} />

                                    </Grid>
                                </Grid>
                                <Grid container item alignItems="flex-start">
                                    <Grid item xs={12} md={11} lg={11}>
                                        {ndwiChartData.data.length != 0 &&
                                            <CustomScatterChart
                                                type="NDWI"
                                                title="Trend Indikator Wasserhaushalt"
                                                dashboardData={ndwiChartData.data}
                                                lowColor="#D14343"
                                                highColor="#55AAFF"
                                                dataValueForLowColor={0}
                                                dataValueForHighColor={1}
                                                defaultColor="#55AAFF"
                                                setInfoPopup={setInfoPopup}
                                            />
                                        }
                                    </Grid>
                                    <Grid item xs={12} md={1} lg={1}>
                                        <TrendScaleGraphic type="NDWI" value={ndwiChartData.trendSlope} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </>
        }

    </>)
    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      }));


    return (
        <>
            {tablet ?

                <DashboardMobile open={open} setOpen={setOpen}>
                    <Box
                        sx={{
                            height: '100%',
                            overflow: 'auto',
                        }}
                    >

                        {content}
                    </Box>

                </DashboardMobile>

                :
                <DashboardDesktop open={open} setOpen={setOpen}>
                    <Box
                        sx={{
                            height: '100%',
                            overflow: 'auto',
                            // display: 'flex',
                        }}
                    >
                        {/* <Grid container rowSpacing={50} columnSpacing={{ xs: 1, sm: 10, md: 10 }}>
                            <Grid item xs={6}>
                                <Item>1</Item>
                            </Grid>
                            <Grid item xs={6}>
                                <Item>2</Item>
                            </Grid>
                            <Grid item xs={6}>
                                <Item>3</Item>
                            </Grid>
                            <Grid item xs={6}>
                                <Item>4</Item>
                            </Grid>
                        </Grid> */}
                        {content}
                    </Box>
                </DashboardDesktop>
            }
        </>
    )

}


